import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {RegistriesService} from "../../service";
import {Observable} from "rxjs";
import {RiskfactorInfo} from "../../model";

@Injectable()
export class RiskfactorInfoResolver implements Resolve<RiskfactorInfo> {
  constructor(private regSrv: RegistriesService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<RiskfactorInfo> {
    const id = route.params.id;
    return this.regSrv.getRiskfactorInfo(id);
  }
}
